import * as XLSX from "xlsx";

const parseJson = (bufferData) => {
  try {
    const rawData = XLSX.readFile(bufferData, { type: "buffer", raw: false, cellDates: true, cellNF: false, cellText: false });
    const sheetName = rawData.SheetNames[0];
    const sheet = rawData.Sheets[sheetName];
    const headers = []
    const decodedRange = XLSX.utils.decode_range(sheet['!ref'])
    let C, R = decodedRange.s.r;
    for (C = decodedRange.s.c; C <= decodedRange.e.c; ++C) {
      let cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
      let hdr = ''
      if (cell && cell.t) {
        hdr = XLSX.utils.format_cell(cell);
      }
      // console.log(C, R, cell, hdr);
      if (hdr.length !== 0) {
        headers.push(hdr.toUpperCase());
      }
    }
    let modifiedWBHeaders = XLSX.utils.sheet_add_aoa(sheet, [headers], { origin: 'A1' })
    const json = XLSX.utils.sheet_to_json(modifiedWBHeaders, { raw: false, dateNF: 'YYYY-MM-DD', skipHidden: true, });
    console.log(json);
    return json 
  } catch (error) {
    console.log(error);
    return []
  }
};

export default parseJson;
